import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { askForDecisionAnalytics } from '../../../decision/decisionUtils';
import { Hyperlink } from '../../../components/Hyperlink';
import { withFeatures } from '../../../features/withFeatures';

export const RawNavUserDecision: FC = () => (
  <>
    <li>
      <Hyperlink
        className="nav-user-dropdown__link"
        href="/getdecision?source=nav_dropdown"
        target="_blank"
        onClick={askForDecisionAnalytics('ask_decision')}
      >
        <FormattedMessage id="navigation/user/components/NavUserDecision.tsx/1" />
      </Hyperlink>
    </li>
    <li>
      <Hyperlink
        className="nav-user-dropdown__link"
        href="/j/envoi"
        source="nav_dropdown"
      >
        <FormattedMessage id="navigation/user/components/NavUserDecision.tsx/2" />
      </Hyperlink>
    </li>
  </>
);

export const NavUserDecision = withFeatures('nav/user')(RawNavUserDecision);
